export default __webpack_public_path__ + "static/media/dots_left.7411b250.svg";